export class FilterValue {
    value: string;
    displayValue: string;
    isIndividual: boolean = true;
    count: string = "0";
}